module.exports = "/* ANALYTICS DATALAYER METHODS */\n\nvar CUBE = CUBE || {};\n(function($) {\n\t\"use strict\";\n\t\n\tvar main = null;\n\t\n\tCUBE.Analytics = CUBE.Analytics || {};\n\tCUBE.Analytics.datalayer = {\n        \n        // NO METHODS\n        \n    };\n    \n\tmain = CUBE.Analytics;\n\n})(jQuery);"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/analytics/legacy/framework/anly-datalayer.legacy.js
// module id = 758
// module chunks = 31